import * as React from 'react';
import { BetterComponent } from '../better-component/better-component';
import { Translate } from '../translate/translate';
import { AppService } from '../../services/index';
import { Container } from 'typescript-ioc/es5';
import './404.scss';

interface IProps {
    label?: string,
}

interface IState {
}

export class NotFound404 extends BetterComponent<IProps, IState> {
    private appService: AppService;

    public constructor(props: IProps) {
        super(props);

        this.appService = Container.get(AppService);
    }

    public render() {
        return (
            <div className="pufferfish-404">
                {this.props.label ?? <Translate name="errors.e404" />}
            </div>
        );
    }
}
